'use strict';
import Analytics from './analytics';

class Favourite {
    constructor() {
        const elem = document.querySelectorAll('.favourite');

        for (let i = 0; i < elem.length; i++) {
            elem[i].addEventListener('click', (e) => this.toggle(e));
        }
    }

    toggle(e) {
        e.preventDefault();
        e.stopPropagation();
        var button = e.currentTarget;
        this.toggleButton(button);
        this.toggleFavourite(button.dataset.ref);
    }

    toggleFavourite(id) {
        var noCacheHeaders = {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        };
        fetch(`/api/v2/favorites/toggle?pageId=${id}`,
            {
                headers: noCacheHeaders,
                method: 'POST',
                credentials: 'include'
            });
    }

    toggleButton(button) {
        const textElement = button.querySelector('.favourite__text')
        if (button.classList.contains('favourite__is-favourite')) {
            button.classList.remove('favourite__is-favourite');
            textElement.innerText = 'Spara som favorit';
            Analytics.removeFavourite();
        } else {
            button.classList.add('favourite__is-favourite');
            textElement.innerText = 'Ta bort från favoriter';
            Analytics.addFavourite();
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new Favourite();
});